import React, { useState, useEffect } from 'react';
import AdminTenantAPI from '../../api/admin/tenants.js';
import AdminLayout from '../../components/admin/AdminLayout.jsx';
import './AdminActivity.css';

const AdminActivity = () => {
  const [activityLogs, setActivityLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadActivityLogs();
  }, []);

  const loadActivityLogs = async () => {
    try {
      setLoading(true);
      const response = await AdminTenantAPI.getAdminActivityLogs({ limit: 50 });
      setActivityLogs(response.logs || []);
    } catch (err) {
      setError('Failed to load activity logs');
      console.error('Error loading activity logs:', err);
    } finally {
      setLoading(false);
    }
  };

  const getActionIcon = (actionType) => {
    switch (actionType) {
      case 'login': return '🔐';
      case 'logout': return '🚪';
      case 'impersonate': return '👤';
      case 'view_tenant': return '👀';
      case 'system_overview': return '📊';
      case 'user_create': return '👤➕';
      case 'password_reset': return '🔑';
      default: return '📋';
    }
  };

  if (loading) {
    return (
      <AdminLayout>
        <div className="admin-activity-loading">
          <div className="loading-spinner"></div>
          <p>Loading activity logs...</p>
        </div>
      </AdminLayout>
    );
  }

  if (error) {
    return (
      <AdminLayout>
        <div className="admin-activity-error">
          <h2>Error Loading Activity Logs</h2>
          <p>{error}</p>
          <button onClick={loadActivityLogs}>Retry</button>
        </div>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      <div className="admin-activity">
        <div className="page-header">
          <h1>Activity Logs</h1>
          <p>System activity and audit trail for all admin actions</p>
        </div>

        <div className="activity-controls">
          <button onClick={loadActivityLogs} className="btn-secondary">
            🔄 Refresh
          </button>
        </div>

        <div className="activity-logs">
          {activityLogs.length === 0 ? (
            <div className="no-logs">
              <p>No activity logs found.</p>
            </div>
          ) : (
            activityLogs.map(log => (
              <div key={log.id} className="log-entry">
                <div className="log-icon">
                  {getActionIcon(log.action_type)}
                </div>
                
                <div className="log-content">
                  <div className="log-header">
                    <span className="log-action">{log.action_type.replace('_', ' ')}</span>
                    <span className="log-time">
                      {new Date(log.created_at).toLocaleString()}
                    </span>
                  </div>
                  
                  <div className="log-details">
                    <div className="log-description">{log.description}</div>
                    <div className="log-user">
                      <span className="user-email">{log.email}</span>
                      <span className="user-id">({log.stytch_member_id})</span>
                    </div>
                  </div>
                  
                  {log.metadata && Object.keys(log.metadata).length > 0 && (
                    <div className="log-metadata">
                      <details>
                        <summary>Metadata</summary>
                        <pre>{JSON.stringify(log.metadata, null, 2)}</pre>
                      </details>
                    </div>
                  )}
                  
                  {(log.ip_address || log.user_agent) && (
                    <div className="log-technical">
                      {log.ip_address && (
                        <span className="tech-detail">IP: {log.ip_address}</span>
                      )}
                      {log.user_agent && (
                        <span className="tech-detail">User Agent: {log.user_agent}</span>
                      )}
                    </div>
                  )}
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminActivity; 